
const modal = {
    namespaced: true,
    state: () => ({
        forms: [],
        currentModal: null,
    }),
    mutations: {

        setCurrentModal(state, modal) {

            state.currentModal = modal;
            if (!!modal) {
                setTimeout(() => { modal.bvModal.show(modal.id) }, 100);

            }
        },

        addItem(state, item) {

        },

        formData(state, data) {

            const index = state.forms.findIndex(item => item.name === data.name);

            if (index != -1) {

                state.forms[index] = data;
            } else {

                state.forms.push(data);
            }


        }

    },
    // actions: { ... }, // promise axios
    getters: {} //computer
}


export default modal;